import { API, Item, Asset, ContentType, PortalItem } from "@thenounproject/lingo-core";
import { createQueryAction } from "./actionCreators";

type Args = {
  itemType?: Item["type"] | PortalItem["type"];
  assetType?: Asset["type"];
};

const [useContentTypes, fetchContentTypes] = createQueryAction<Args, ContentType[], ContentType[]>(
  {
    entity: "kits",
    action: "fetchContentTypes",
    denormalize: false,
  },
  async ({ args: { itemType, assetType } }) => {
    const res = await API.call<{ contentTypes: Record<string, ContentType> }>({
      endpoint: `meta/content_types`,
      method: "GET",
      normalize: false,
      query: {
        item_type: itemType,
        type: assetType,
      },
    });
    // content_types is a map of { type : ContentType }
    const contentTypes = res.result.contentTypes;
    return { result: Object.values(contentTypes), entities: {} };
  }
);

export default useContentTypes;
export { fetchContentTypes };
